import { VehicleMappingType, VehicleMappingTypeKey, VehicleMappingTypeKeys } from "./enums";
import { CreateVehicleMappingFormItem, UpdateVehicleMappingFormItem, VehicleMapping } from "./types";

export const VEHICLE_TYPES_PATH: {
  [key in VehicleMappingType]: {
    name: string;
    keyId: keyof Pick<UpdateVehicleMappingFormItem, `${VehicleMappingTypeKey}Id`>;
    keyName: keyof Pick<UpdateVehicleMappingFormItem, `${VehicleMappingTypeKey}Name`>;
    keyIdentifier: keyof Pick<
      CreateVehicleMappingFormItem | UpdateVehicleMappingFormItem,
      `${VehicleMappingTypeKey}Identifier`
    >;
  };
} = {
  [VehicleMappingType.ALLIANZ]: {
    name: VehicleMappingTypeKeys.ALLIANZ,
    keyId: `${VehicleMappingTypeKeys.ALLIANZ}Id`,
    keyName: `${VehicleMappingTypeKeys.ALLIANZ}Name`,
    keyIdentifier: `${VehicleMappingTypeKeys.ALLIANZ}Identifier`,
  },
  [VehicleMappingType.COLONNADE]: {
    name: VehicleMappingTypeKeys.COLONNADE,
    keyId: `${VehicleMappingTypeKeys.COLONNADE}Id`,
    keyName: `${VehicleMappingTypeKeys.COLONNADE}Name`,
    keyIdentifier: `${VehicleMappingTypeKeys.COLONNADE}Identifier`,
  },
  [VehicleMappingType.CSOB_MTPL]: {
    name: VehicleMappingTypeKeys.CSOB_MTPL,
    keyId: `${VehicleMappingTypeKeys.CSOB_MTPL}Id`,
    keyName: `${VehicleMappingTypeKeys.CSOB_MTPL}Name`,
    keyIdentifier: `${VehicleMappingTypeKeys.CSOB_MTPL}Identifier`,
  },
  [VehicleMappingType.CSOB_CRASH]: {
    name: VehicleMappingTypeKeys.CSOB_CRASH,
    keyId: `${VehicleMappingTypeKeys.CSOB_CRASH}Id`,
    keyName: `${VehicleMappingTypeKeys.CSOB_CRASH}Name`,
    keyIdentifier: `${VehicleMappingTypeKeys.CSOB_CRASH}Identifier`,
  },
  [VehicleMappingType.DEFEND]: {
    name: VehicleMappingTypeKeys.DEFEND,
    keyId: `${VehicleMappingTypeKeys.DEFEND}Id`,
    keyName: `${VehicleMappingTypeKeys.DEFEND}Name`,
    keyIdentifier: `${VehicleMappingTypeKeys.DEFEND}Identifier`,
  },
  [VehicleMappingType.GENERALI]: {
    name: VehicleMappingTypeKeys.GENERALI,
    keyId: `${VehicleMappingTypeKeys.GENERALI}Id`,
    keyName: `${VehicleMappingTypeKeys.GENERALI}Name`,
    keyIdentifier: `${VehicleMappingTypeKeys.GENERALI}Identifier`,
  },
  [VehicleMappingType.KOMUNALNA]: {
    name: VehicleMappingTypeKeys.KOMUNALNA,
    keyId: `${VehicleMappingTypeKeys.KOMUNALNA}Id`,
    keyName: `${VehicleMappingTypeKeys.KOMUNALNA}Name`,
    keyIdentifier: `${VehicleMappingTypeKeys.KOMUNALNA}Identifier`,
  },
  [VehicleMappingType.KOOPERATIVA]: {
    name: VehicleMappingTypeKeys.KOOPERATIVA,
    keyId: `${VehicleMappingTypeKeys.KOOPERATIVA}Id`,
    keyName: `${VehicleMappingTypeKeys.KOOPERATIVA}Name`,
    keyIdentifier: `${VehicleMappingTypeKeys.KOOPERATIVA}Identifier`,
  },
  [VehicleMappingType.PILLOW]: {
    name: VehicleMappingTypeKeys.PILLOW,
    keyId: `${VehicleMappingTypeKeys.PILLOW}Id`,
    keyName: `${VehicleMappingTypeKeys.PILLOW}Name`,
    keyIdentifier: `${VehicleMappingTypeKeys.PILLOW}Identifier`,
  },
  [VehicleMappingType.UNION]: {
    name: VehicleMappingTypeKeys.UNION,
    keyId: `${VehicleMappingTypeKeys.UNION}Id`,
    keyName: `${VehicleMappingTypeKeys.UNION}Name`,
    keyIdentifier: `${VehicleMappingTypeKeys.UNION}Identifier`,
  },
  [VehicleMappingType.UNIQA]: {
    name: VehicleMappingTypeKeys.UNIQA,
    keyId: `${VehicleMappingTypeKeys.UNIQA}Id`,
    keyName: `${VehicleMappingTypeKeys.UNIQA}Name`,
    keyIdentifier: `${VehicleMappingTypeKeys.UNIQA}Identifier`,
  },
};

export const VEHICLE_IDENTIFIER_DELIMITER = "<->";

export const parseVehicleMappingsFromIdentifiers = (
  item: CreateVehicleMappingFormItem | UpdateVehicleMappingFormItem,
) => {
  const itemCopy: CreateVehicleMappingFormItem | UpdateVehicleMappingFormItem = { ...item };

  Object.values(VehicleMappingType).forEach((type) => {
    const typePath = VEHICLE_TYPES_PATH[type];
    const mappingIdentifier = itemCopy[typePath.keyIdentifier];

    if (mappingIdentifier) {
      const identifierTokens = mappingIdentifier.split(VEHICLE_IDENTIFIER_DELIMITER);
      itemCopy[typePath.keyId] = identifierTokens[0] as string;
      itemCopy[typePath.keyName] = identifierTokens[1] as string;
    } else {
      delete itemCopy[typePath.keyId];
      delete itemCopy[typePath.keyName];
    }

    delete itemCopy[typePath.keyIdentifier];
  });

  return itemCopy;
};

export const parseVehicleMappingsToUpdateFormItems = (...items: VehicleMapping[]) => {
  const updateItems = items.map<UpdateVehicleMappingFormItem>((mapping) => ({
    ...mapping,
    createdAt: undefined,
    updatedAt: undefined,
  }));

  updateItems.forEach((item) => {
    Object.values(VehicleMappingType).forEach((type) => {
      const idValue = item[VEHICLE_TYPES_PATH[type].keyId];
      const nameValue = item[VEHICLE_TYPES_PATH[type].keyName];
      item[VEHICLE_TYPES_PATH[type].keyIdentifier] =
        idValue && nameValue ? idValue + VEHICLE_IDENTIFIER_DELIMITER + nameValue : undefined;
    });
  });

  return updateItems;
};
